<template lang="pug">
  .not-access-container
    b-container
      b-row.justify-content-center
        b-col(md="5" style="text-align:center;")
          div.justify-content-center.mb-3
            b-img(src="@/assets/403Image.png", alt="Sin acceso")
          span.spanStyle No tienes acceso a esta sección
          p.textStyle.mb-4 El recurso al que estás tratando de acceder está limitado únicamente a usuarios autorizados.
          div.d-flex.justify-content-center
            b-button.buttonStyles(variant="primary", @click="goToRoot()") Aceptar
</template>

<script>
export default {
  methods: {
    goToRoot() {
      this.$router.push({ name: 'root' }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.spanStyle {
  font-size: 25px;
  font-weight: bold;
}
.textStyle {
  font-size: 16px;
  font-weight: 100;
}
.buttonStyles {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 147px;
  height: 35px;
}
.not-access-container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    min-height: 0;
    border-top: 2px solid #0e5ccf;

    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
